import { render, staticRenderFns } from "./AutomaticSubmissionAccepted.vue?vue&type=template&id=7d981084"
import script from "./AutomaticSubmissionAccepted.vue?vue&type=script&lang=js"
export * from "./AutomaticSubmissionAccepted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports